var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _ = require("lodash");

var BaseResource = require("./BaseResource");

var Analytics = /*#__PURE__*/function (_BaseResource) {
  "use strict";

  _inherits(Analytics, _BaseResource);

  var _super = _createSuper(Analytics);

  function Analytics(client) {
    var _this;

    _classCallCheck(this, Analytics);

    _this = _super.call(this, client);
    _this.path = "".concat(client.options.siteId, "/sites/");
    return _this;
  }

  _createClass(Analytics, [{
    key: "insertSite",
    value: function insertSite() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "", data, options);
    }
  }, {
    key: "getAllSites",
    value: function getAllSites() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._get(this.path + "", options);
    }
  }, {
    key: "getSite",
    value: function getSite(id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get(this.path + id, options);
    }
  }]);

  return Analytics;
}(BaseResource);

module.exports = Analytics;